import { useState } from 'react'
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap'

import { refundPayment } from '../../../services/payments'

export function RefundPackageModal({ itemId, forceUpdate, transactionId, transactionToken, maxRefund, hasRefunded }) {
  const [show, setShow] = useState(false)
  const [refundSum, setRefundSum] = useState(0)
  const [errorMsg, setErrorMsg] = useState('')
  const [isProcessing, setIsProcessing] = useState(false)

  const confirmBtnHandler = async () => {
    setIsProcessing(true)
    setErrorMsg('')

    const paymentFormData = {
      packageId: itemId,
      paymentTransactionId: transactionId,
      paymentTransactionToken: transactionToken,
      refundSum: refundSum,
    }

    try {
      const response = await refundPayment(paymentFormData)
      if (response.status === 200) {
        setShow(false)
        forceUpdate()
        alert(`Refund processed successfully! Amount: ${refundSum}`)
      } else {
        setErrorMsg(`Refund Failed: ${response.error || 'Unknown error'}`)
      }
    } catch (error) {
      const errorRes = error?.response
      console.error('Refund error:', errorRes)

      let errorMessage = 'Refund processing failed'
      if (errorRes?.data?.error) {
        errorMessage = errorRes.data.error
      } else if (errorRes?.data?.message) {
        errorMessage = errorRes.data.message
      } else if (errorRes?.data) {
        errorMessage = errorRes.data
      }

      setErrorMsg(errorMessage)
    } finally {
      setIsProcessing(false)
    }
  }

  const cancelBtnHandler = () => {
    setShow(false)
    setErrorMsg('')
    forceUpdate()
  }

  const handleChange = ({ target }) => {
    const currentAmount = target.value

    if (currentAmount > maxRefund) {
      setRefundSum(maxRefund)
    } else {
      setRefundSum(Number(currentAmount))
    }
  }

  const isRefundEnabled = !hasRefunded && transactionId && transactionToken && maxRefund

  return (
    <div>
      <Button
        variant='link'
        disabled={!isRefundEnabled || isProcessing}
        onClick={() => setShow(true)}
        style={{ width: 'fit-content', padding: '0px' }}
      >
        {isProcessing ? 'Processing...' : 'Refund'}
      </Button>

      <Modal size='lg' show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Process Refund</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Form style={{ textAlign: 'left' }}>
              <div style={{ marginBottom: '15px' }}>
                <strong>Shipping paid: {maxRefund}</strong>
              </div>

              <Form.Group controlId='formBasicEmail2'>
                <Form.Label>Refund amount</Form.Label>
                <Form.Control
                  value={refundSum}
                  type='number'
                  onChange={handleChange}
                  disabled={isProcessing}
                  min='0'
                  max={maxRefund}
                  step='0.01'
                />
              </Form.Group>

              <Form.Check
                checked={refundSum === maxRefund}
                onChange={() => {
                  setRefundSum(maxRefund)
                }}
                type='checkbox'
                label='Full refund'
                name='setMaxAmount'
                id='setMaxAmount'
                disabled={isProcessing}
                style={{ marginBottom: '15px' }}
              />

              {errorMsg && (
                <Alert variant='danger' style={{ marginBottom: '15px' }}>
                  {errorMsg}
                </Alert>
              )}

              <div style={{ display: 'flex', gap: '10px' }}>
                <Button onClick={confirmBtnHandler} disabled={isProcessing || refundSum <= 0} variant='primary'>
                  {isProcessing ? (
                    <>
                      <Spinner as='span' animation='border' size='sm' role='status' aria-hidden='true' style={{ marginRight: '5px' }} />
                      Processing...
                    </>
                  ) : (
                    'Confirm Refund'
                  )}
                </Button>
                <Button variant='secondary' onClick={cancelBtnHandler} disabled={isProcessing}>
                  Cancel
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
